import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router,NavigationEnd } from '@angular/router';
//import { LocalstorageService } from 'src/app/global/localstorage.service';
import { MatDialog } from '@angular/material';
import { LocalstorageService } from '../../../app/global/localstorage.service';
import { BusService } from 'src/app/main/busservices/busservice.service';
import { first, groupBy, mergeMap, toArray } from 'rxjs/operators';
import * as data from '../../../assets/projectconfig.json';
import { ViewRoutesService } from '../viewroutes/viewroutes.service';
import { from, interval, Subscription } from 'rxjs';
import { PlanjourneyService } from '../planjourney/planjourney.service';
import { StringFilterCellComponent } from '@progress/kendo-angular-grid';
import { UpdatefontsizeService } from '../../services/updatefontsize.service';
import { LoginDialog,HeaderComponent } from '../../shared/layout/header/header.component'


@Component({
  selector: 'app-busservices',
  templateUrl: './busservices.component.html',
  styleUrls: ['./busservices.component.scss']
})
export class BusservicesComponent implements OnInit {

  public RouteNoForMap: any;
  public NameOfRoutes: any;
  num: any;
  time:any;

  public isLogin: any;
  isShow: any;
  NavName: string;
  getlen: string;
  BusServicesLan: string;
  HomeLan: string;
  FareConcessionsLan: string;
  FareConcessionsLan2: string;
  RegularBusesLan: string;
  RailwayStationServicesLan: string;
  RouteMap: string;
  BusNetworkLan: string;
  routenolan: string;
  routenamelan: string;
  routemaplan: string;
  timetablelan: string;
  stopslan: string;
  categorylan: string;
  FaraConcessionData:any;
  concessionlan: string;
  nonaclan:string;
  aclan:string;
  kidslan: string;
  blinddiffrentlan: string;
  helperscompanionslan: string;
  number1: string;
  number2: string;
  number3: string;
  searchlan: string;
  PassesLan: string;
  RailwayStationServicesLan2: string;
  RegularBusespara1: string;
  RegularBusespara2: string;
  para2: string;
  para3: string;
  para4: string;
  ComingsoonLan: string;
  SelectedNavBar: number;
  Name: string;
  HonName: string;
  urlName: string;
  loadTime:any;
    Railwaystationservicespara1: string;
  passesimageLan: string;
  Fareconessionimage: string;
  parsedData: any[];
  price1: string;
  price2: string;
  price3: string;
  price4: string;
  price5: string;
  price6: string;
  passdura: string;
  Day1: string;
  Day2: string;
  Day3: string;
  Day4: string;
  Day5: string;
  Day6: string;
  amount: string;
  passengertype: string;
  passtype: string;
  general: string;
  openend: string;
  consession: string;
  con1: string;
  con2: string;
  con3: string;
  con4: string;
  con5: string;
  con6: string;
  con7: string;
  gene1: string;
  student: string;
  consess: string;
  pay1: string;
  pay2: string;
  public TypeofRoute: any;
  public showPass=0;

  fontSize = 14;
  NASize = this.fontSize;

  constructor(public router: Router,public headercomponenet:HeaderComponent, private route: ActivatedRoute, public dialog: MatDialog, public BusService: BusService, private updateFont : UpdatefontsizeService) {
    this.getlen = LocalstorageService.getLanguage("language");
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
          this.time = Date.now();
       }
   });
  }



  ngOnInit() {

    this.GetRoutesList();
    this.GetFareConcessionData();
    this.num = this.route.snapshot.queryParamMap.get('page');
    this.Getdata(this.num);
    this.isLogin =LocalstorageService.getLocal('Token');

    if (this.getlen == 'en') {
      this.BusServicesLan = "BUS SERVICES";
      this.HomeLan = "HOME";
      this.FareConcessionsLan = "FARE CONCESSIONS";
      this.FareConcessionsLan2 = "FARE CONCESSIONS"
      this.RegularBusesLan = "REGULAR BUSES";
      this.RailwayStationServicesLan = "RAILWAY STATION AND AIRPORT SERVICES";
      this.RouteMap = "ROUTE";
      this.RailwayStationServicesLan2 = "Frequently Asked Questions (FAQs)";
      this.BusNetworkLan = "BUS NETWORK";
      this.routenolan = "Route No";
      this.routenamelan = "Route Name";
      this.routemaplan = "Route Map";
      this.timetablelan = "Timetable";
      this.stopslan = "Stops";
      this.categorylan = "Category";
      this.concessionlan = "Concessions";
      this.nonaclan = "Non Ac";
      this.aclan = "Ac";
      this.kidslan = "Kids 5-10 years";
      this.blinddiffrentlan = "Blind and Differently-abled";
      this.helperscompanionslan = "Helpers/Companions to Differently-abled";
      this.number1 = "50%";
      this.number2 = "75%";
      this.number3 = "50%";
      this.passengertype = "Passenger Type";
      this.passtype = "Pass Type";
      this.general = "General";
      this.openend = "Open Ended (Anywhere, Any Route)";
      this.passdura = "Pass Duration";
      this.Day1 = "1 Day";
      this.Day2 = "3 Days";
      this.Day3 = "7 Days";
      this.Day4 = "30 Days";
      this.Day5 = "90 Days";
      this.Day6 = "180 Days";
      this.amount = "Amount (Rs.)";
      this.price1 = "Rs.75/-";
      this.price2 = "Rs.200/-";
      this.price3 = "Rs.400/-";
      this.price4 = "Rs.1500/-";
      this.price5 = "Rs.3750/-";
      this.price6 = "Rs.6750/-";
      this.consession = "Concession (%)";
      this.con1 = "Nil";
      this.con2 = "12.50%";
      this.con3 = "26.80%";
      this.con4 = "33.33%";
      this.con5 = "44.44%";
      this.con6 = "50%";
      this.con7 = "66.60%";
      this.gene1 = "General (Fixed Route)";
      this.student = "Student (Fixed Route)";
      this.consess = "Concession";

      this.pay1 = "33.33%";
      this.pay2 = "44.44%";

      this.searchlan = "Search With Route No Or Route Name";
      this.PassesLan = "PASSES";
      this.RegularBusespara1 = "Presently the routes cover a radius of 20 kms in and around Nashik area. Nearly 250 buses providing services to the passengers every day.";
      this.RegularBusespara2 = "See bus route schedule for more information.";

      this.Railwaystationservicespara1 = "Nashik city will be connected to Nashik Road Railway Station by city bus with 5 minutes frequency. Also, it will be connected to Nashik Airport with frequent service.";

      this.para3 = "When customers do have questions that extend beyond the range of your FAQ page, you should have options available that directly connect them with your support team. You could add a link that opens a new support ticket or even just list your call center's phone number at the bottom of the page.The idea is that customers shouldn't have to navigate back to your home page just to locate your company's email or phone number.";
      this.para4 = "This committee, specified under The MMC Act is the most important committee of the corporation. The councilors at their first meeting elect the Standing Committee, consisting of 16 councillors, after the general election. The Standing Committee/General Board essentially governs the functioning of the Corporation on behalf of the 122 councillors. It is the policy making body of the Corporation and makes all decisions with respect to the establishment and finances of the Corporation as per the various provisions of the MMC Act 1949.";
      this.passesimageLan="../../../../assets/images/Passes-en.jpg";
      this.Fareconessionimage="../../../../assets/images/Fareconsession-en.jpg";
      this.ComingsoonLan = "Coming Soon..."
      this.Name = "Shri Kailas Jadhav, IAS";
      this.HonName = "Hon'ble Chairman & Managing Director";
    } else if (this.getlen == 'mr') {
      this.BusServicesLan = "बस सेवा";
      this.HomeLan = "मुख्यपृष्ठ";
      this.RegularBusesLan = "नियमित बसेस";
      this.RegularBusespara1 = "सध्याच्या वाहतुक नियोजनानुसार नाशिक शहर व त्याच्या २० कि.मी. पर्यंतच्या भागांमध्ये दररोज सुमारे 250 बसेस सुरु करुन नागरिकांना सेवा पुरविण्यात येणार आहे.";
      this.RegularBusespara2 = "अधिक माहितीसाठी बस मार्गाचे वेळापत्रक पाहावे. "
      this.RailwayStationServicesLan = "रेल्वे स्टेशन व विमानतळ सेवा";
      this.RailwayStationServicesLan2 = "नेहमी विचारले जाणारे प्रश्न (वारंवार विचारले जाणारे प्रश्न)";
      this.BusNetworkLan = "बस नेटवर्क";
      this.routenolan = "मार्ग क्र.";
      this.routenamelan = "मार्गाचे नाव";
      this.routemaplan = "मार्ग नकाशा";
      this.timetablelan = "वेळापत्रक";
      this.stopslan = "बस थांब्यांची यादी";
      this.categorylan = "वर्गवारी";
      this.concessionlan = "सवलत";
      this.nonaclan = "नॉन एसी";
      this.aclan = "एसी";
      this.kidslan = "लहान मुले ०५ ते १० वर्षा आतील";
      this.blinddiffrentlan = "अंध व अपंग";
      this.helperscompanionslan = "मदतनीस (अंध व अपंग यासाठी)";
      this.number1 = "५०%";
      this.number2 = "७५%";
      this.number3 = "५०%";
      this.passengertype = "प्रवाशांचे प्रकार";
      this.passtype = "पास प्रकार";
      this.general = "पासवर दिल्या जाणा-या सवलती";
      this.openend = "अमयागद पास";
      this.passdura = "पासकालावधी";
      this.Day1 = "१ दिवस";
      this.Day2 = "३ दिवस";
      this.Day3 = "७ दिवस";
      this.Day4 = "३० दिवस";
      this.Day5 = "९० दिवस";
      this.Day6 = "१८० दिवस";
      this.amount = "किंमत (रु)";
      this.price1 = "रु.७५/-";
      this.price2 = "रु.२००/-";
      this.price3 = "रु.४००/-";
      this.price4 = "रु.१५००/-";
      this.price5 = "रु.३७५०/-";
      this.price6 = "रु.६७५०/-";
      this.consession = "सवलत (%)";
      this.con1 = "-";
      this.con2 = "१२ .५०%";
      this.con3 = "२६.८०%";
      this.con4 = "३३.३३%";
      this.con5 = "४४ .४४%";
      this.con6 = "५०%";
      this.con7 = "६६.६०%";
      this.gene1 = "सवगसाधारण (निश्चित मार्ग )";
      this.student = "विद्यार्थी (निश्चित मार्ग )";
      this.consess = "सवलत";
      this.pay1 = "२० दिवसाच्या भाडयावर ३० दिवस प्रवास";
      this.pay2 = "५० दिवसाच्या भाडयावर ९० दिवस प्रवास";
      this.searchlan = "मार्गाचे नाव किंवा मार्ग क्र. द्वारे शोधा";
      this.FareConcessionsLan = "तिकिटांवर सवलती";
      this.FareConcessionsLan2 = "तिकीटदरावर दिल्या जाणा-या सवलती";
      this.PassesLan = "पास माहिती";
      this.ComingsoonLan = "लवकरच येत आहे…";
      this.Railwaystationservicespara1 = "'CITILINC' शहर बससेवेचे नियोजन ओझर विमानतळ आणि नाशिक रोड रेल्वे स्थानकाचे वेळापत्रक लक्षात घेऊन करण्यात आले आहे. नाशिक रोड येथून नाशिक शहरातील सर्व महत्वाच्या ठिकाणी आणि तपोवन डेपोतून ओझर विमानतळ मार्गे मोहाडी पर्यंत बसेस उपलब्ध असणार आहेत. ";
      this.para2 = "FAQ pages are intended as an initial support option for customers looking for an immediate answer to a quick question or problem. It shouldn't replace your knowledge base or your entire support team, but rather supplement your support channels as an additional, lightweight resource.";
      this.para3 = "When customers do have questions that extend beyond the range of your FAQ page, you should have options available that directly connect them with your support team. You could add a link that opens a new support ticket or even just list your call center's phone number at the bottom of the page.The idea is that customers shouldn't have to navigate back to your home page just to locate your company's email or phone number.";
      this.para4 = "This committee, specified under The MMC Act is the most important committee of the corporation. The councilors at their first meeting elect the Standing Committee, consisting of 16 councillors, after the general election. The Standing Committee/General Board essentially governs the functioning of the Corporation on behalf of the 122 councillors. It is the policy making body of the Corporation and makes all decisions with respect to the establishment and finances of the Corporation as per the various provisions of the MMC Act 1949.";
      this.passesimageLan="../../../../assets/images/Passes-mr.jpg";
      this.Fareconessionimage="../../../../assets/images/Fareconsession-mr.jpg";
      this.Name = "श्री कैलास जाधव, भा.प्र.से.";
      this.HonName = "मा. अध्यक्ष व व्यवस्थापकीय संचालक";
    } else {
      this.BusServicesLan = "BUS SERVICES";
      this.HomeLan = "HOME";
      this.FareConcessionsLan = "FARE CONCESSIONS";
      this.RegularBusesLan = "REGULAR BUSES";
      this.RailwayStationServicesLan = "RAILWAY STATION SERVICES";
      this.RailwayStationServicesLan2 = "Frequently Asked Questions (FAQs)";
      this.BusNetworkLan = "BUS NETWORK";
      this.PassesLan = "PASSES";
      this.Railwaystationservicespara1 = "Nashik city will be connected to Nashik Road Railway Station by city bus with 5 minutes frequency.";      this.para3 = "When customers do have questions that extend beyond the range of your FAQ page, you should have options available that directly connect them with your support team. You could add a link that opens a new support ticket or even just list your call center's phone number at the bottom of the page.The idea is that customers shouldn't have to navigate back to your home page just to locate your company's email or phone number.";
      this.para4 = "This committee, specified under The MMC Act is the most important committee of the corporation. The councilors at their first meeting elect the Standing Committee, consisting of 16 councillors, after the general election. The Standing Committee/General Board essentially governs the functioning of the Corporation on behalf of the 122 councillors. It is the policy making body of the Corporation and makes all decisions with respect to the establishment and finances of the Corporation as per the various provisions of the MMC Act 1949.";
      this.passesimageLan="../../../../assets/images/Passes-en.jpg";
      this.Fareconessionimage="../../../../assets/images/Fareconsession-en.jpg";
    }

    this.SelectedNavBar = this.num;

     //update font size daynamic
     this.updateFont.currentFontSource$.subscribe((type) => {
      if(type == '+'){
        if (this.fontSize < (this.NASize + 3)) {
          this.fontSize++;
        }
      } else if(type == '-'){
        if (this.fontSize > (this.NASize - 3)) {
          this.fontSize--;
        }
      } else{
          this.fontSize = this.NASize;
      }
    });
   // this.headercomponenet.skipToMailSection();
  }


  ngAfterViewInit(){
    this.loadTime = Date.now() - this.time;
    // alert("ngafterinit Time: "+ this.loadTime);
     LocalstorageService.setPageLoadTime("busservices",this.loadTime);

this.pageLoadTime();

 }


  pageLoadTime(){
    this.BusService.pageLoadTimeInsert().pipe(first()).subscribe(result =>{

    })
  }

  public RouteStartpointItems: Array<{ routeid: string, routename: string, routeno: any, routenametype: any }>;


  GetRoutesList() {
    this.BusService.GetAllRoutes().pipe(first()).subscribe(result => {
      this.RouteStartpointItems = JSON.parse(result.data);
      // //console.log(this.RouteStartpointItems);
    });
  }

  filterMetadata = { count: 0 };
  filtre: any;



  Getdata(b) {

    var URLName='Busservices';
    this.SelectedNavBar=b;
    this.isShow = b;
    this.isLogin =  LocalstorageService.getLocal('Token');

    if(b==5)
    {
      LocalstorageService.setLocal('geturl',URLName);   // Set Clicked URL into LocalStorageService
      if(this.isLogin == null){
        this.showPass=0;
        //this.router.navigate(['/Login']);
        const dialogRef = this.dialog.open(LoginDialog);

        dialogRef.afterClosed().subscribe(result => {
          //console.log(`Dialog result: ${result}`);
        });
      }
      else{
        this.showPass=1;
        this.router.navigate(['/' + URLName.split('?')[0]], { queryParams: { page: 5 }});
      }
    }

  }
  goOnTo(id) {
    this.urlName = "Onlineservices";
    this.router.navigate(['/' + this.urlName.split('?')[0]], { queryParams: { page: id } });
  }

  openBusDialog(RouteNo) {
    this.RouteNoForMap = RouteNo;
    LocalstorageService.setLocal("RouteNoForMap",RouteNo);
    const dialogRef = this.dialog.open(RouteMapDialog);

    dialogRef.afterClosed().subscribe(result => {
      //console.log(`Dialog result: ${result}`);
    });
  }

  openTimeTableDialog(RouteNo,displayfullroutename) {

    LocalstorageService.setLocal("RouteNoForMap", RouteNo);
    LocalstorageService.setLocal("NameOfRoutes", displayfullroutename);
    const dialogRef = this.dialog.open(TimeTableDialog);

    dialogRef.afterClosed().subscribe(result => {
      //console.log(`Dialog result: ${result}`);
    });
  }

  openStopsDialog(RouteNo) {
    LocalstorageService.setLocal("RouteNoForMap",RouteNo);
    const dialogRef = this.dialog.open(StopsDialog);

    dialogRef.afterClosed().subscribe(result => {
      //console.log(`Dialog result: ${result}`);
    });
  }

  GetFareConcessionData(){
    this.BusService.GetFareConcessionData().pipe(first()).subscribe(result =>{

      this.FaraConcessionData = JSON.parse(result.data);

    })
    }
}




@Component({
  selector: 'route.design.popup',
  templateUrl: 'route.design.popup.html',
})
export class RouteMapDialog{
  @ViewChild('map', { static: true }) mapElement: any;
  map: google.maps.Map;

  public isLoadingHome: boolean = false;
  public timeline_tripdetailsdata: Array<any> = [];
  public isTableHasData: boolean;
  public showTripDetailContent: Boolean = true;
  public markerdes: google.maps.Marker;
  public markersource: google.maps.Marker;
  public currmarker: google.maps.Marker;
  public subscription1: Subscription;
  public TripRouteNo: any;
  public TripVehicleNo: any;
  public activeinfowindow: google.maps.InfoWindow;
  public routewaypointsmapdata: Array<any> = [];
  public StationList: any =[];
  public markers = [];
  public polyline: google.maps.Polyline;

  constructor(private viewRoutesService: ViewRoutesService, private journeyService: PlanjourneyService,
    private BusService: BusService) {}

  ngOnInit(): void{
    var lat = data[0].Latitude;
    var long = data[0].Longitude;
    const mapProperties = {
      center: new google.maps.LatLng(lat, long),
      zoom: 15,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    };
    this.map = new google.maps.Map(this.mapElement.nativeElement, mapProperties);
    var rno = LocalstorageService.getLocal("RouteNoForMap");
    //this.TripPlotOnMap();
    this.StationsListByRoute();
  }

  public introuteid: number;
  public routeDetailsGroupBy: any = [];
  public routeDetails: Array<{ routeid: string, stopno: string, stopname: string, distance: string, tripid: string, eta: string, tripname: string, iscovered: string }>
  GetDetailsOfRoutes(routeid) {
    this.introuteid = routeid;
    this.routeDetailsGroupBy = [];
    this.viewRoutesService.GetRouteDetails(routeid).pipe(first()).subscribe(result => {
      this.routeDetails = JSON.parse(result.data); //list of all trip records
      //group by with trip id
      const example = from(this.routeDetails).pipe(groupBy(person => person.tripid),
        mergeMap(group => group.pipe(toArray())));
      example.subscribe(val => this.routeDetailsGroupBy.push(val[0], val[val.length - 1]))
    });
  }

  CreateInfoWindow(marker, title) {
    const infowindow = new window['google'].maps.InfoWindow({
      content: title
    });
    marker.setMap(this.map)
    google.maps.event.addListener(marker, 'click', () => {
      if (this.activeinfowindow) { this.activeinfowindow.close(); }
      infowindow.open(this.map, marker);
      this.activeinfowindow = infowindow;
    });
  }

  StationsListByRoute() {
    var routeid = LocalstorageService.getLocal("RouteNoForMap");
    this.BusService.GetAllStationsOnRoute(Number(routeid),1).pipe(first()).subscribe(result => {
      this.StationList = JSON.parse(result.data);

      var latlongmarkerbounds = [];
      for (var i = 0; i < this.StationList.length; i++) {
        var lat = this.StationList[i]["center_lat"];
        var long = this.StationList[i]["center_lon"];
        var stationname = this.StationList[i]["displayname"];
       // var displayname = this.StationList[i]["displayname"];
        var title = "<b>Stop Name</b> : " + stationname;
        let latLng = { lat: Number(lat), lng: Number(long) };
        latlongmarkerbounds.push(new google.maps.LatLng(Number(lat), Number(long)));
        this.map.setCenter(new google.maps.LatLng(Number(lat), Number(long)));
        var icon;
        if (i === 0) {
          icon = {
            url: "assets/images/mapIcon.1.svg", // url
          }
        }
        else if (i === this.StationList.length - 1) {
          icon = {
            url: "assets/images/mapIcon.2.svg", // url
          }
        }
        else {
          icon = {
            url: "assets/images/mapIcon.svg", // url
          }
        }

        const marker = new google.maps.Marker({
          position: latLng,
          map: this.map,
          title: stationname,
          icon: icon
        });
        this.CreateInfoWindow(marker, title);
        this.markers.push(marker);
      }
      });
      this.PlotRoute();
  }

  PlotRoute() {
    var routeid = LocalstorageService.getLocal("RouteNoForMap");

    this.journeyService.GetRouteWayPoints(routeid).pipe(first()).subscribe(result => {
      this.routewaypointsmapdata = JSON.parse(result.data);
      var path = [];
      for (var i = 0; i < this.routewaypointsmapdata.length; i++) {
        var lat1 = this.routewaypointsmapdata[i]["routelat"];
        var long1 = this.routewaypointsmapdata[i]["routelong"];
        path.push(new google.maps.LatLng(Number(lat1), Number(long1)));
      }

      this.polyline = new google.maps.Polyline({
        map: this.map,
        path: path,
        strokeColor: '#114a97',
        strokeOpacity: 0.8,
        strokeWeight: 6,
        geodesic: true,
      })
      this.polyline.setMap(this.map);
    });
  }

}

@Component({
  selector: 'time_table.design.popup',
  templateUrl: 'time_table.design.popup.html',
})
export class TimeTableDialog{
  ShowTimeTable: boolean = true;
  public TimeTableList: any = [];
  public StationName: any = [];
  getlen: string;
  TimetableLan: any;
  DisRouteName: any;
  DisRouteType: any;
  DisplayFullRouteNAme: any;

  constructor(private BusService: BusService) {
    this.getlen = LocalstorageService.getLanguage("language");
  }

  ngOnInit() {
    this.DisRouteName = LocalstorageService.getLocal("NameOfRoutes");
    this.GetRouteTimeTable();
    if(this.getlen=='en'){
      this.TimetableLan='Time Table';
    } else if(this.getlen=='mr') {
      this.TimetableLan ='वेळापत्रक';
    } else {
      this.TimetableLan='Time Table';
    }
  }

  GetRouteTimeTable() {

    var routeid = LocalstorageService.getLocal("RouteNoForMap");
    // this.DisRouteName = LocalstorageService.getLocal("NameOfRoutes");
    this.DisplayFullRouteNAme = LocalstorageService.getLocal("NameOfRoutes");
     //console.log(this.DisplayFullRouteNAme);
    this.BusService.GetAllStationsOnRoute(Number(routeid), 2).pipe(first()).subscribe(result => {
      this.TimeTableList = JSON.parse(result.data);
      var ListLength = this.TimeTableList.length;
      if(ListLength>0) {
        this.ShowTimeTable = true;
      } else {
        this.ShowTimeTable = false;
      }
    });
  }

}

@Component({
  selector: 'stops.design.popup',
  templateUrl: 'stops.design.popup.html',
  styleUrls: ['./busservices.component.scss']
})
export class StopsDialog{

  public routeid: string;
  public StationList: any =[];
  public SrNo: string;
  public BusStops: string;
  public getlen: string;
  constructor(private BusService: BusService) {}

  ngOnInit(){
    this.routeid = LocalstorageService.getLocal("RouteNoForMap");
    this.getlen = LocalstorageService.getLanguage("language");
    if(this.getlen == 'en') {
      this.SrNo = "SR No";
      this.BusStops = "Bus Stops";
    } else if(this.getlen == 'mr') {
      this.SrNo = "अनु.क्र.";
      this.BusStops = "बस थांब्यांची यादी";
    }
    this.StationsListByRoute();
  }

  StationsListByRoute() {

    this.BusService.GetAllStationsOnRoute(Number(this.routeid), 3).pipe(first()).subscribe(result => {
      this.StationList = JSON.parse(result.data);
    });
  }

}
